import { Button, Dialog, DialogActions, DialogContent, Slide } from "@material-ui/core";
import { unwrapResult } from "@reduxjs/toolkit";
import React, { useState } from "react";
import { connect } from "react-redux";
import { editCustomer } from "../redux/customerOperations";
import CustomerForm from "./CustomerForm";

//TODO: loading
const CustomerEditDialog = (props) => {  
  const [isOpen, setIsOpen] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const [customerData, setCustomerData] = useState(null);

  const onConfirm = () => {
    const editCustomerData = {
      ...customerData,
      uuid: props.customer.uuid,
    };

    props.editCustomer(editCustomerData).then(unwrapResult).then((result) => {
      setIsOpen(false);
    }).catch(errorCode => {
      setErrorMessage('Something went wrong, please try again later. ' + (errorCode != null ? '(' + errorCode + ')' : ''));             
    });
  }

  return (
    <Dialog open={isOpen} TransitionComponent={Transition} onExited={(e) => {props.onClose()}}>
      <DialogContent>
        <div className="dialog-content">
          <h2>{'Edit customer'}</h2><br/>
          <CustomerForm initialData={props.customer} onDataEdited={(data) => setCustomerData(data)}/>
          {errorMessage != null && <p className="error dialog-error">{errorMessage}</p>}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => setIsOpen(false)}>
          Cancel
        </Button>
        <Button onClick={(e) => onConfirm()}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  editCustomer: (customer) => dispatch(editCustomer(customer)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(CustomerEditDialog);


